<template>
  <div>
    <Navigation />


    <!-- Start Gallery Area -->
    <div class="gallery-area pb-70">
      <div class="section-title">
        <h2>Gallery</h2>
      </div>

      <div class="container">
        <div class="section-title">
          <h4>City Life Center Pictures</h4>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/clc1.jpg" alt="image" />

              <a href="assets/img/clc1.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/clc2.jpeg" alt="image" />

              <a href="assets/img/clc2.jpeg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box ">
              <img class="w-75" src="assets/img/clc3.jpg" alt="image" />

              <a href="assets/img/clc3.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img class="w-75" src="assets/img/clc4.jpg" alt="image" />

              <a href="assets/img/clc4.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/clc5.jpeg" alt="image" />

              <a href="assets/img/clc5.jpeg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/clc6.jpeg" alt="image" />

              <a href="assets/img/clc6.jpeg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/outreach/outreach7.jpg" alt="image" />

              <a href="assets/img/outreach/outreach7.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/outreach/outreach8.jpg" alt="image" />

              <a href="assets/img/outreach/outreach8.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="section-title">
          <h4>IPDYI Pictures</h4>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi1.jpg" alt="image" />

              <a href="assets/img/ipdyi/ipdyi1.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi2.JPG" alt="image" />

              <a href="assets/img/ipdyi/ipdyi2.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi3.JPG" alt="image" />

              <a href="assets/img/ipdyi/ipdyi3.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi4.JPG" alt="image" />

              <a href="assets/img/ipdyi/ipdyi4.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi5.JPG" alt="image" />

              <a href="assets/img/ipdyi/ipdyi5.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi6.JPG" alt="image" />

              <a href="assets/img/ipdyi/ipdyi6.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi7.jpg" alt="image" />

              <a href="assets/img/ipdyi/ipdyi7.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/ipdyi/ipdyi8.jpg" alt="image" />

              <a href="assets/img/ipdyi/ipdyi8.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="section-title">
          <h4>Rhema Prophetic Center Pictures</h4>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/rpc/rpc1.JPG" alt="image" />

              <a href="assets/img/rpc/rpc1.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>




          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box ">
              <img src="assets/img/rpc/rpc2.JPG" alt="image" />
               
              <a href="assets/img/rpc/rpc2.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>
        

         

<!--          <div class="col-lg-3 col-md-6 col-sm-6">-->
<!--            <div class="single-gallery-box">-->
<!--              <img src="assets/img/rpc/rpc3.JPG" alt="image" />-->

<!--              <a href="assets/img/rpc/rpc3.JPG" class="gallery-btn" data-imagelightbox="popup-btn">-->
<!--                <i class="flaticon-search"></i>-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-lg-3 col-md-6 col-sm-6">-->
<!--            <div class="single-gallery-box">-->
<!--              <img src="assets/img/rpc/rpc4.JPG" alt="image" />-->

<!--              <a href="assets/img/rpc/rpc4.JPG" class="gallery-btn" data-imagelightbox="popup-btn">-->
<!--                <i class="flaticon-search"></i>-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/rpc/rpc4.JPG" alt="image" />
                 
                  <p class="card-text ">Cross section of attendees </p>
                   
              <a href="assets/img/rpc/rpc4.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/rpc/rpc5.JPG" alt="image" />
                <p class="card-text text-center">Prayer line at RPC </p> 
            
              <a href="assets/img/rpc/rpc5.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/rpc/rpc6.JPG" alt="image" />

              <a href="assets/img/rpc/rpc6.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>





        <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box ">
              <img src="assets/img/rpc/rpc7.JPG" alt="image" />

              <p class="card-text text-center">Interactive session with Major 1 </p> 
               

              <a href="assets/img/rpc/rpc7.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>



          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box ">
              <img src="assets/img/rpc/rpc8.JPG" alt="image" />
                
                  <p class="card-text text-center">Bible teaching by Dr. Goodhead </p> 
                 
                <a href="assets/img/rpc/rpc8.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>



          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/rpc/rpc9.JPG" alt="image" />
                
                  <p class="card-text text-center">Leaders prayer meeting at mountain </p> 
                 
                 <a href="assets/img/rpc/rpc9.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>



          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/rpc/rpc10.JPG" alt="image" />
                
                  <p class="card-text text-center">Dr. Goodhead prophesying over Gaborone and Botswana </p> 
                 
                  
               

              <a href="assets/img/rpc/rpc10.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>


          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box ">
              <img src="assets/img/rpc/rpc111.JPG" alt="image" />
                
                  <p class="card-text text-center">Dr. Goodhead ministering at<br> block 9 Prayer Center <br>(Starting venue of RPC) </p> 
                 
                  
               

              <a href="assets/img/rpc/rpc11.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>


          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/rpc/rpc12.JPG" alt="image" />
                
                  <p class="card-text text-center">Core Discipleship pastors of RPC<br>Left to right<br> Apostle Paul, Bishop Isaac, Pastor Dennis </p> 
                 
               

              <a href="assets/img/rpc/rpc12.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>













        </div>
      </div>
      <div class="container">
        <div class="section-title">
          <h4>Business and Leadership Institute Pictures</h4>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/bli/bli1.jpg" alt="image" />

              <a href="assets/img/bli/bli1.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/bli/bli2.jpg" alt="image" />

              <a href="assets/img/bli/bli2.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/bli/bli3.jpg" alt="image" />

              <a href="assets/img/bli/bli3.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="section-title">
          <h4>Trauma Healing Centre Pictures</h4>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/thc/thc1.JPG" alt="image" />

              <a href="assets/img/thc/thc1.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/thc/thc2.jpg" alt="image" />

              <a href="assets/img/thc/thc2.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/thc/thc3.JPG" alt="image" />

              <a href="assets/img/thc/thc3.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/thc/thc4.JPG" alt="image" />

              <a href="assets/img/thc/thc4.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/thc/thc5.JPG" alt="image" />

              <a href="assets/img/thc/thc5.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/thc/thc6.JPG" alt="image" />

              <a href="assets/img/thc/thc6.JPG" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row1111">

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-gallery-box">
              <img src="assets/img/clc/clc_plan.jpg" alt="image" />

              <a href="assets/img/clc/clc_plan.jpg" class="gallery-btn" data-imagelightbox="popup-btn">
                <i class="flaticon-search"></i>
              </a>
              <div class="causes-content">
                <h4>Proposed CLC Plan</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Gallery Area -->
    <Footer />
  </div>
</template>


<script>
import Navigation from "./navBar/Navigation";
import Footer from './Footer'

export default {
  name: "Home",
  components: {
       Navigation,
       Footer }
};
</script>

<style scoped>
</style>
